/*******************
AJAX CORE
--
Este arquivo contém os métodos base para uso de ajax
*********************/

function cryo_EscapeIE(v) {
    console.error("cryo_EscapeIE - use of obsolete function.")
}

function cryo_GetHTTPObject() {
    console.error("cryo_GetHTTPObject - use of obsolete function.")
}

function cryo_Open(url, params, fn) {
    console.error("cryo_Open - use of obsolete function.")
}

function cryo_HandleHttpResponse() {
    console.error("cryo_HandleHttpResponse - use of obsolete function.")
}

function cryo_ComboSelect(idCombo, nomePrimaryKey, nomeTabela, listaCamposAPreencher, listaCamposBD, callbackFunction) {
    console.error("cryo_ComboSelect - use of obsolete function.")
}

function cryo_GenericSelect(valorPrimaryKey, nomePrimaryKey, nomeTabela, listaCamposAPreencher, listaCamposBD, callbackFunction, ignoreNulls, codFonteDados, url, isOrquestraField) {
    console.error("cryo_GenericSelect - use of obsolete function.")
}

function cryo_GetComboItems(valorPrimaryKey, nomePrimaryKey, nomeTabela, listaCamposAPreencher, listaCamposBD, callbackFunction, ignoreNulls, orderByColumn) {
    console.error("cryo_GetComboItems - use of obsolete function.")
}

function cryo_HasRows(xmlResultante) {
    console.error("cryo_HasRows - use of obsolete function.")
}

function cryo_PopulateFields(xmlResultante, listaCamposAPreencher, listaCamposBD, functionToExecToFields, ignoreNulls, isMultipleTable, objFromMultipleTable) {
    console.error("cryo_PopulateFields - use of obsolete function.")
}

function cryo_RemoveChild(node) {
    console.error("cryo_RemoveChild - use of obsolete function.")
}

function cryo_PopulateCombo(xmlResultante, listaCamposAPreencher, listaCamposBD, functionToExecToFields, ignoreNulls, fieldType, parentNode, fieldName, fieldXName, isMultipleTable, objFromMultipleTable) {
    console.error("cryo_PopulateCombo - use of obsolete function.")
}

function cryo_ClearFields(listaCamposAPreencher, objeto) {
    console.error("cryo_ClearFields - use of obsolete function.")
}

function populaCombo(obj, text, value, type, parentNode, fieldName, fieldXName) {
    console.error("populaCombo - use of obsolete function.")
}

function cryo_GetFieldValue(xmlText, tag) {
    console.error("cryo_GetFieldValue - use of obsolete function.")
}

function cryo_PopulateSuggestion(xmlResultante, idCampoDescricaoForm, idCampoCodigoForm, idCampoDescricaoDB, idCampoCodigoBD, objField, isOrquestraField) {
    console.error("cryo_PopulateSuggestion - use of obsolete function.")
}

function cryo_BlockUnblockTaskButtons(blnDisabled) {
    console.error("cryo_BlockUnblockTaskButtons - use of obsolete function.")
}

function cryo_ClearSuggestion() {
    console.error("cryo_ClearSuggestions - use of obsolete function.")
}

function cryo_ShowSuggestion() {
    console.error("cryo_ShowSuggestion - use of obsolete function.")
}

function cryo_ShowOrHideSuggestion(display) {
    console.error("cryo_ShowOrHideSuggestion - use of obsolete function.")
}

function cryo_SetSearch(descriptionFieldValue, codeFieldId, codeFieldValue, isOrquestraField) {
    console.error("cryo_SetSearch - use of obsolete function.")
}

function orquestraFieldJsonRequest(objNotToUpdate, codFlowExecute) {
    console.error("orquestraFieldJsonRequest - use of obsolete function.")
}

function cryo_ControlSuggest(objField, CodGroupValue, isOrquestraField) {
    console.error("cryo_ControlSuggest - use of obsolete function.")
}

function cryo_TaskClaimOwnership(CodFlowExecuteTask, callbackFunction) {

    console.warn(window.appvars.ownership.msgClaimLegacy)

    ownership = GetOwnershipInstance();
    ownership.claim(callbackFunction);

}

function cryo_TaskUnclaimOwnership(CodFlowExecuteTask, callbackFunction) {

    console.warn(window.appvars.ownership.msgUnclaimLegacy)

    ownership = GetOwnershipInstance();
    ownership.unclaim(callbackFunction);

}


var ownership;
function cryo_TaskClaimOwnershipWrapper() {

    console.warn(window.appvars.ownership.msgClaimWrapperLegacy)

    ownership = GetOwnershipInstance();

    function claimOwnership_callback(ret) {

        if (ret.success.codFlowExecuteTask) {
            
            // confirmar se esta alocada para o usuario corrente
            window.setTimeout(cryo_ConfirmTaskOwnership, 1000);

        }
    }

    ownership.claim(claimOwnership_callback);
}

function cryo_TaskUnclaimOwnershipWrapper() {

    console.warn(window.appvars.ownership.msgClaimWrapperLegacy)

    ownership = GetOwnershipInstance();
    ownership.unclaim();
}

// efetua requisicao ajax para confirmar se a tarefa esta alocada para o usuario atual
function cryo_ConfirmTaskOwnership()
{
    console.warn(window.appvars.ownership.msgConfirmLegacy)

    ownership = GetOwnershipInstance();

    function confirmOwnership_callback(ret) {
        if (!ret.success.isTaskOwner) {
            // esta alocada para outro usuario deve dar redirect
            document.location.href = "wfFlow_Execute_Error.aspx";
        }
    }

    ownership.confirm(confirmOwnership_callback); 

}

function GetOwnershipInstance() {
    return ownership ? ownership : new Ownership();
}